import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Tooltip,
  Box,
  IconButton,
  Avatar,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { Iconify, MuiDialog } from "src/components";
import moment from "moment";
import { useAppContext } from "src/hooks";
import { s3baseUrl } from "src/config";
import { useSnackbar } from "notistack";
import {
  _delete_recurring_event_list,
  _delete_recurring_single_event,
} from "src/DAL/dashboard";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { LoadingButton } from "@mui/lab";

export default function EventDetailDialog({
  openModal,
  onClose,
  event,
  selectedDate,
  getCalendarTasks,
  onEdit,
}) {
  if (!event) {
    return;
  }
  const { enqueueSnackbar } = useSnackbar();
  const { dispatch_get_user_profile } = useAppContext();
  const userProfile = dispatch_get_user_profile();

  const [processing, setProcessing] = useState(false);
  const [singleProcessing, setSingleProcessing] = useState(false);
  const [deleteEvent, setDeleteEvent] = useState(false);
  const [selectedDeleteOption, setSelectedDeleteOption] = useState("single");

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  // ---------------------- selected recurring day
  const selectedDay = event.recurring_dates?.find((item) =>
    moment(item.actual_time).isSame(moment(selectedDate), "day")
  );

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const openDelDialog = () => {
    setDeleteDialogOpen(true);
  };
  const closeDelDialog = () => {
    setProcessing(false);
    setDeleteDialogOpen(false);
  };

  const openSingleDelDialog = () => {
    setSingleDeleteDialogOpen(true);
  };
  const closeSingleDelDialog = () => {
    setSingleProcessing(false);
    setSingleDeleteDialogOpen(false);
  };

  const deleteFullEvent = async () => {
    if (!event) {
      return;
    }
    setProcessing(true);
    const result = await _delete_recurring_event_list(event._id);
    if (result.code === 200) {
      enqueueSnackbar("Event list deleted successfully", {
        variant: "success",
      });
      getCalendarTasks();
      onClose();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setProcessing(false);
  };

  const deleteSingleEvent = async () => {
    if (!event || !selectedDate) return;
    const matchedOccurrence = event.recurring_dates.find((occurrence) => {
      const occurrenceDate = new Date(occurrence.creation_date).toDateString();
      const selected = new Date(selectedDate).toDateString();
      return occurrenceDate === selected;
    });

    const data = {
      event_id: event._id,
      occurance_id: matchedOccurrence._id,
    };

    setSingleProcessing(true);
    const result = await _delete_recurring_single_event(data);
    if (result.code === 200) {
      enqueueSnackbar("Event deleted successfully", { variant: "success" });
      getCalendarTasks();
      onClose();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setSingleProcessing(false);
  };

  useEffect(() => {
    if (openModal) {
      console.log(event, "==> Event <==");
    }
  }, [openModal]);

  return (
    <>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: 600 } }}
        open={openModal}
        onClose={onClose}
      >
        <DialogTitle sx={{ p: "16px 16px" }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            {deleteEvent === true ? (
              <Typography fontWeight={500}>
                Are you sure you want to delete this event?
              </Typography>
            ) : (
              <div className="d-flex align-items-center">
                {moment(selectedDate).format("dddd, D MMMM YYYY")}
              </div>
            )}

            {deleteEvent === false && (
              <IconButton size="small" onClick={handleMenuClick}>
                <MoreVertIcon />
              </IconButton>
            )}

            <Menu anchorEl={anchorEl} open={openMenu} onClose={handleMenuClose}>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  onEdit(event);
                }}
                sx={{ fontSize: "12px" }}
              >
                <Iconify
                  icon="mdi:pencil-outline"
                  sx={{ width: "15px", height: "15px", mr: 1 }}
                  color="#637381"
                />
                Edit
              </MenuItem>
              <MenuItem
                sx={{ fontSize: "12px" }}
                onClick={() => {
                  handleMenuClose();
                  setDeleteEvent(true);
                  setSelectedDeleteOption("single");
                }}
              >
                <Iconify
                  icon="fluent:delete-24-regular"
                  sx={{
                    height: "15px",
                    width: "15px",
                    mr: 1,
                    color: "#C23232",
                  }}
                />
                Delete
              </MenuItem>
            </Menu>
          </Box>
        </DialogTitle>
        <DialogContent className="pb-0">
          {!deleteEvent && (
            <>
              <div
                style={{
                  // backgroundColor: "#f5f5f5",
                  // padding: "5px 8px",
                  // borderRadius: "4px",
                  display: "flex",
                  alignItems: "baseline",
                }}
              >
                <Iconify
                  icon="simple-line-icons:calender"
                  style={{
                    marginRight: "8px",
                    color: event.color,
                    flexShrink: 0,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 500,
                    wordBreak: "break-word",
                  }}
                >
                  {event?.event_title}
                </Typography>
              </div>
              <div className="mt-2">
                <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                  Repate
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    padding: "5px 8px",
                    borderRadius: "4px",
                    width: "max-content",
                    marginBottom: "10px",
                  }}
                >
                  <Iconify
                    icon="codicon:bell-dot"
                    style={{
                      marginRight: "8px",
                      fontSize: "16px",
                      color: "#637381",
                      flexShrink: 0,
                    }}
                  />
                  <Typography sx={{ fontSize: "13px" }}>
                    {event.number_of_occurances <= 1 &&
                    !event.specified_days?.length // hide "Do not repeat" if specified_days have value
                      ? "Do not repeat"
                      : event.interval_type === "daily"
                      ? event.number_of_intervals === 1
                        ? "Every day"
                        : `Every ${event.number_of_intervals} days`
                      : event.interval_type === "weekly"
                      ? `Every ${event.number_of_intervals} ${
                          event.number_of_intervals > 1 ? "weeks" : "week"
                        }`
                      : event.interval_type === "monthly"
                      ? `Every ${event.number_of_intervals} ${
                          event.number_of_intervals > 1 ? "months" : "month"
                        }`
                      : event.interval_type === "yearly"
                      ? `Every ${event.number_of_intervals} ${
                          event.number_of_intervals > 1 ? "years" : "year"
                        }`
                      : ""}

                    {/* WEEKLY DAYS */}
                    {event.interval_type === "weekly" &&
                      // event.number_of_occurances > 1 &&
                      event.specified_days &&
                      event.specified_days.length > 0 && (
                        <>
                          {" on "}
                          {event.specified_days.length === 7
                            ? "All days"
                            : event.specified_days
                                .map(
                                  (d) =>
                                    [
                                      "Sun",
                                      "Mon",
                                      "Tue",
                                      "Wed",
                                      "Thu",
                                      "Fri",
                                      "Sat",
                                    ][d]
                                )
                                .join(", ")}
                        </>
                      )}
                    {/* MONTHLY DAYS */}
                    {event.interval_type === "monthly" && (
                      <>
                        {" on "}
                        {event.specified_days.includes(-1)
                          ? "Last Day"
                          : `Day ${event.specified_days.join(", ")}`}
                      </>
                    )}
                  </Typography>
                </div>
                {/* hides when do_not_repate */}
                {!(event.number_of_occurances <= 1) && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#f5f5f5",
                      padding: "5px 8px",
                      borderRadius: "4px",
                      width: "max-content",
                    }}
                  >
                    <Iconify
                      icon="mingcute:time-line"
                      style={{
                        marginRight: "8px",
                        fontSize: "16px",
                        color: "#637381",
                        flexShrink: 0,
                      }}
                    />
                    <Typography sx={{ fontSize: "13px" }}>
                      {/* YEARLY FORMAT  */}
                      {event.interval_type === "yearly" &&
                        event.recurring_start_date && (
                          <>
                            {" on "}
                            {moment(event.recurring_start_date).format(
                              "D MMMM"
                            )}
                          </>
                        )}
                      {/* End Conditions */}
                      {event.recurring_end_date && (
                        <>
                          {" "}
                          Until{" "}
                          {moment(event.recurring_end_date).format(
                            "D MMM YYYY"
                          )}
                        </>
                      )}
                      {event.number_of_occurances &&
                        !event.recurring_end_date && (
                          <> , Repeat {event.number_of_occurances} times</>
                        )}
                    </Typography>
                  </div>
                )}
              </div>
              {/* ----------------- event description -------------- */}
              {selectedDay?.event_data?.event_description && (
                <div className="mt-2">
                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    Description
                  </Typography>
                  <div
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedDay.event_data.event_description,
                      }}
                      style={{
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        fontSize: "13px",
                      }}
                    />
                  </div>
                </div>
              )}

              <hr className="divider" />
              {event?.recurring_schedule_created_by === userProfile.user_id && (
                <div>
                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    Scheduled by
                  </Typography>
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "3px 8px",
                      borderRadius: "4px",
                      width: "max-content",
                    }}
                  >
                    <Avatar
                      src={s3baseUrl + userProfile.image}
                      sx={{ width: "22px", height: "22px" }}
                    >
                      {userProfile.first_name.substring(0, 1)}{" "}
                      {userProfile.last_name.substring(0, 1)}
                    </Avatar>
                    <Typography sx={{ fontSize: "13px" }}>
                      {userProfile.first_name + " " + userProfile.last_name}
                    </Typography>
                  </div>
                </div>
              )}
            </>
          )}
          {/* ========================================================================= */}
          {deleteEvent === true && (
            <Box sx={{ p: "0px 12px 12px" }}>
              {event.number_of_occurances <= 1 ? (
                <Typography sx={{ fontSize: "12px" }} noWrap>
                  "{event?.event_title}"
                </Typography>
              ) : (
                <Stack spacing={2}>
                  <RadioGroup
                    value={selectedDeleteOption}
                    onChange={(e) => setSelectedDeleteOption(e.target.value)}
                  >
                    <FormControlLabel
                      value="single"
                      control={<Radio size="small" />}
                      label={
                        <Typography sx={{ fontSize: "14px" }}>
                          This event
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="entire"
                      control={<Radio size="small" />}
                      label={
                        <Typography sx={{ fontSize: "14px" }}>
                          All events
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Stack>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {deleteEvent === true ? (
            <>
              <Button
                variant="text"
                color="inherit"
                onClick={() => {
                  setDeleteEvent(false);
                  setSelectedDeleteOption("single");
                }}
              >
                Cancel
              </Button>
              <LoadingButton
                onClick={() => {
                  if (selectedDeleteOption === "single") {
                    deleteSingleEvent();
                  } else if (selectedDeleteOption === "entire") {
                    deleteFullEvent();
                  }
                }}
                loading={
                  selectedDeleteOption === "single"
                    ? singleProcessing
                    : processing
                }
                // color="error"
                // variant="contained"
                sx={{
                  backgroundColor: "#C23232",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#A12B2B",
                  },
                  "& .MuiCircularProgress-root": {
                    color: "#fff",
                  },
                }}
              >
                Delete
              </LoadingButton>
            </>
          ) : (
            <Button onClick={onClose} color="primary">
              Close
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
